import { ca } from '@cian/analytics';

export function trackContactBlockShow(newbuildingId: number, sellerType: 'builders' | 'agents') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'author_contacts_block',
    action: 'show_sopr',
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
      },
    ],
    page: {
      extra: {
        seller_type: sellerType,
        pageTypeJK: 'Normal',
      },
    },
  });
}
